module.exports = __webpack_public_path__ + "img/chiefLensman.dc975044.png";